module.exports = __webpack_public_path__ + "static/media/memoriesText.18ebdb6d.png";